<div class="modal-header">
    <h4 class="modal-title pull-left">Change Password</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <form [formGroup]="form">
        <div class="form-group">
            <!-- <label>Old Password</label> -->
            <div class="input-group mb-3">
                <input [type]="oldPasswordVisible ? 'text' : 'password'" class="form-control" placeholder="Old Password"
                    formControlName="oldPassword" [ngClass]="{ 'is-invalid': isSubmitted && f.password.errors }">
                <div class="input-group-append pointer" (click)="oldPasswordVisible = !oldPasswordVisible">
                    <span class="input-group-text btn">
                        <img src="assets/images/eye.svg" style="height: 18px; width: 18px;">
                    </span>
                </div>
                <div *ngIf="isSubmitted && f.password.errors" class="invalid-feedback">
                    <div *ngIf="f.password.errors.required">Old Password is required</div>
                </div>
            </div>
        </div>
        <div class="form-group">
            <!-- <label>New Password</label> -->
            <label class="d-block">
                <!-- Password --><span class="float-right text-uppercase small"
                    [style.color]="strength.color">{{strength.message}}</span>
            </label>
            <div class="input-group mb-3">
                <input [type]="passwordVisible ? 'text' : 'password'" class="form-control" placeholder="New Password"
                    formControlName="password" [ngClass]="{ 'is-invalid': isSubmitted && f.password.errors }">
                <div class="input-group-append pointer" (click)="passwordVisible = !passwordVisible">
                    <span class="input-group-text btn">
                        <img src="assets/images/eye.svg" style="height: 18px; width: 18px;">
                    </span>
                </div>
                <div *ngIf="isSubmitted && f.password.errors" class="invalid-feedback">
                    <div *ngIf="f.password.errors.required">Password is required</div>
                </div>
            </div>

            <app-password-strength-bar (strength)="strength = $event" [passwordToCheck]="form.controls.password.value">
            </app-password-strength-bar>

        </div>
        <div class="form-group">
            <!-- <label>Confirm Password</label> -->
            <div class="input-group mb-3">
                <input [type]="confirmPasswordVisible ? 'text' : 'password'" class="form-control"
                    placeholder="Confirm Password" formControlName="confirmPassword"
                    [ngClass]="{ 'is-invalid': isSubmitted && f.password.errors }">
                <!-- <div class="input-group-append pointer" (click)="confirmPasswordVisible = !confirmPasswordVisible">
                    <span class="input-group-text btn">
                        <img src="assets/images/eye.svg" style="height: 18px; width: 18px;">
                    </span>
                </div> -->
                <div *ngIf="isSubmitted && f.password.errors" class="invalid-feedback">
                    <div *ngIf="f.password.errors.required">Confirm Password is required</div>
                </div>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <div *ngIf="form.enabled">
        <!-- <button class="btn btn-primary mr-2" (click)="onUpdate()" [disabled]="isProfileUpdating || form.invalid"> -->
        <button class="btn btn-light mr-2" (click)="cancel();">Cancel</button>
        <am-button (click)="submitForm()" [text]="'Save'" [isLoading]="isButtonDisabled"></am-button>
    </div>
</div>